import React from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";
import { CreateHandoutData } from "../components";


type Props = {};

const CreateHandoutContainer = (props: Props) => {

    return (
        <AppLayout>

            <CreateHandoutData />

        </AppLayout>
    );
};

export default CreateHandoutContainer;
